import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Sedancabservicemumbai() {



const cardData = {
  keyword: " Sedan Cab Service Mumbai",

headingDescription:
  "Omshree Cab offers professional and comfortable sedan cab service in Mumbai for travelers who want smooth, safe, and efficient transportation around the city and nearby destinations. Whether you need a sedan cab for airport transfers, corporate travel, city sightseeing, family outings, or outstation trips, our service provides well‑maintained, air‑conditioned sedans driven by experienced chauffeurs familiar with Mumbai’s roads and routes. We offer flexible booking options including one‑way rides, round trips, hourly rentals, and full‑day packages at transparent pricing. Our sedan fleet includes popular models like Toyota Etios, Honda City, Swift Dzire, and other comfortable sedans ideal for solo travelers, couples, and business professionals. With punctual pickups from any location in Mumbai and 24/7 customer support, Omshree Cab ensures dependable and affordable sedan cab service in the city.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India is one of Mumbai’s most iconic landmarks located on the waterfront in South Mumbai. The historic arch monument draws visitors daily for photography, sightseeing, and ferry rides to Elephanta Island. The surrounding Colaba area also offers vibrant street markets, cafes, and heritage buildings. Using a comfortable sedan cab service makes it easy to reach this famous destination without worrying about city traffic or parking."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a scenic coastal road along the Arabian Sea, famous as the Queen’s Necklace for its beautiful lights at night. Visitors come here to enjoy sunset views, evening walks, and refreshing sea breezes. The long promenade connects several attractions in South Mumbai, making it an ideal route for a sedan cab sightseeing tour. A sedan cab ride provides a smooth and comfortable experience along this iconic stretch."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of Mumbai’s most popular beaches, attracting people for relaxation, sea views, and delicious street food like pav bhaji, bhel puri, and pani puri. The beach becomes especially lively in the evenings when families and tourists gather to enjoy the sunset. A sedan cab service makes it convenient to visit Juhu Beach comfortably from any part of Mumbai."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is a revered Hindu temple dedicated to Lord Ganesha and one of the city’s most visited spiritual sites. Devotees and tourists alike come here to seek blessings and admire the temple’s architecture. During festivals like Ganesh Chaturthi, the temple attracts large crowds. A sedan cab service provides comfortable transportation to reach this popular spiritual destination while avoiding parking and traffic challenges."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "Bandra Worli Sea Link is Mumbai’s modern cable‑stayed bridge offering spectacular views of the Arabian Sea and the city skyline. Driving across the bridge is a memorable experience, especially at sunset or night when the lights create a stunning atmosphere. A sedan cab ride ensures a smooth and scenic trip across this iconic bridge while exploring other nearby parts of the city."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a famous religious shrine located on a small island off the coast of Mumbai, accessed via a narrow walkway during low tide. The white marble structure and serene surroundings attract visitors from different backgrounds. Using a sedan cab makes it easy to travel to this spiritual landmark without the hassle of navigating busy city roads or finding parking."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock‑cut caves located on Elephanta Island in Mumbai Harbour, known for their impressive sculptures dedicated to Lord Shiva. Tourists typically take a ferry from the Gateway of India to reach the island and explore the historic cave temples. A comfortable sedan cab provides hassle‑free transport to the ferry departure point, ensuring a smooth start to the journey."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a large urban forest reserve offering trekking, nature walks, and the ancient Kanheri Caves. Visitors come here to experience a refreshing escape from city life, with activities like cycling, picnics, and wildlife spotting. A sedan cab ride ensures a relaxed and comfortable journey to this natural attraction, suitable for families and solo travelers."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a bustling street market in South Mumbai known for its vibrant culture, shopping stalls, and local eateries. Visitors can shop for clothes, accessories, handicrafts, and souvenirs while enjoying the lively atmosphere. Using a sedan cab makes it easy to reach this popular marketplace and integrate it into a full sightseeing itinerary."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also called Pherozeshah Mehta Gardens, are terraced landscaped gardens located on Malabar Hill, offering panoramic views of Marine Drive and the Arabian Sea. Visitors enjoy peaceful walks, photography, and relaxation amidst greenery. A sedan cab provides a comfortable mode of transport to this scenic spot and allows flexible travel time to explore nearby attractions."
  }
],



services: [
{
name: "Sedan Cab Service Mumbai",
description: "Sedan cab service in Mumbai offers comfortable and reliable transportation for passengers traveling within the city and nearby destinations. Sedan vehicles provide smooth rides, spacious seating, and excellent fuel efficiency for daily travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for airport transfers, business travel, and family trips. Air-conditioned interiors ensure relaxed journeys for passengers. Flexible booking options allow convenient ride reservations anytime."
},
{
name: "Sedan Taxi Service Mumbai",
description: "Sedan taxi service in Mumbai provides convenient city transportation with comfortable four-seater vehicles suitable for daily travel. Sedan taxis offer smooth driving performance on city roads and highways. Professional drivers ensure safe driving and timely pickup services across Mumbai. Pickup services are available from homes, offices, hotels, and transport hubs. Ideal for corporate travel, airport transfers, and personal trips. Spacious interiors ensure comfortable rides for passengers. Flexible booking options allow quick and easy taxi reservations."
},
{
name: "Sedan Car Rental Mumbai",
description: "Sedan car rental in Mumbai offers affordable and comfortable travel options for passengers needing reliable city transportation. Sedan vehicles provide smooth suspension, good mileage, and comfortable seating for long journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, and airport terminals. Ideal for business meetings, tourism visits, and daily commuting. Air-conditioned interiors ensure comfortable travel experiences. Flexible rental options allow convenient ride scheduling."
},
{
name: "Sedan Cab Booking Mumbai",
description: "Sedan cab booking in Mumbai allows passengers to easily reserve comfortable sedan vehicles for city and outstation travel. Online and phone booking options provide instant ride confirmation. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel, family trips, and airport transfers. Comfortable interiors ensure relaxed journeys for passengers. Flexible booking options allow easy ride scheduling anytime."
},
{
name: "Sedan Airport Cab Mumbai",
description: "Sedan airport cab in Mumbai provides reliable transportation for passengers traveling to or from airport terminals. Sedan vehicles offer comfortable seating and smooth travel between the airport and city destinations. Professional drivers monitor flight schedules to ensure punctual pickup and drop services. Pickup services are available from homes, offices, hotels, and airport terminals across Mumbai. Ideal for business travelers, tourists, and family airport transfers. Air-conditioned interiors ensure comfortable journeys with luggage. Flexible booking options allow advance reservations."
},
{
name: "Sedan Outstation Taxi Mumbai",
description: "Sedan outstation taxi in Mumbai offers comfortable long-distance travel for passengers visiting destinations outside the city. Sedan vehicles provide smooth highway performance and comfortable seating for extended journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, and transport hubs. Ideal for weekend trips, pilgrimage tours, and family vacations. Spacious interiors ensure relaxed travel experiences. Flexible one-way and round-trip booking options make travel planning easy."
},
{
name: "Sedan One Way Cab Mumbai",
description: "Sedan one way cab in Mumbai offers economical intercity transportation without return charges. Sedan vehicles provide comfortable seating and smooth driving performance on highways and city roads. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, and airport terminals. Ideal for airport transfers, business travel, and tourism visits. Air-conditioned interiors ensure relaxed journeys for passengers. Flexible booking options allow quick ride reservations."
},
{
name: "Sedan Round Trip Taxi Mumbai",
description: "Sedan round trip taxi in Mumbai provides convenient transportation for passengers planning return journeys to nearby destinations. Sedan vehicles offer comfortable seating and smooth highway travel for long-distance trips. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, and airport terminals. Ideal for family tours, corporate trips, and weekend travel. Air-conditioned interiors ensure comfortable journeys. Flexible round-trip packages allow convenient travel planning."
},
{
name: "Cheap Sedan Cab Mumbai",
description: "Cheap sedan cab in Mumbai offers budget-friendly transportation for passengers looking for economical travel options. Sedan vehicles provide comfortable seating and smooth rides suitable for city travel and short-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and marketplaces. Ideal for students, daily commuters, and budget travelers. Air-conditioned interiors ensure comfortable journeys. Flexible booking options allow convenient ride scheduling anytime."
},
{
name: "Best Sedan Taxi Mumbai",
description: "Best sedan taxi in Mumbai provides premium transportation with well-maintained vehicles and professional drivers. Sedan cars offer comfortable seating and smooth driving experience suitable for city and highway travel. Professional drivers ensure punctual pickup and courteous service throughout the journey. Pickup services are available across Mumbai including homes, offices, hotels, and airport terminals. Ideal for corporate travel, tourism visits, and airport transfers. Comfortable interiors ensure relaxed rides for passengers. Flexible booking options allow quick taxi reservations."
},
{
name: "Sedan Cab Per Km Mumbai",
description: "Sedan cab per km rate in Mumbai provides transparent pricing for passengers traveling in comfortable sedan vehicles. These cars offer smooth driving performance and economical fuel consumption for city and highway travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for outstation trips, corporate travel, and family journeys. Air-conditioned interiors ensure relaxed travel experiences. Clear pricing structure ensures affordable and transparent fares."
},
{
name: "Sedan Taxi Booking Mumbai",
description: "Sedan taxi booking in Mumbai allows passengers to easily reserve comfortable sedan vehicles for city rides and long-distance journeys. Online and phone booking options provide instant ride confirmation. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel, family trips, and airport transfers. Comfortable interiors ensure relaxed journeys for passengers. Flexible booking options allow easy taxi reservations anytime."
},
{
name: "Sedan Family Cab Mumbai",
description: "Sedan family cab in Mumbai provides comfortable transportation ideal for families traveling together. Sedan vehicles offer spacious seating and smooth travel suitable for city rides and weekend trips. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, railway stations, and airport terminals. Ideal for family outings, temple visits, and vacations. Air-conditioned interiors ensure relaxed journeys during travel. Flexible booking options allow easy ride reservations."
},
{
name: "Sedan Corporate Cab Mumbai",
description: "Sedan corporate cab in Mumbai provides reliable transportation for business executives and corporate employees. Sedan vehicles offer comfortable seating and professional travel suitable for office transfers and meetings. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from offices, hotels, airports, and business districts. Ideal for corporate meetings, airport transfers, and executive travel. Comfortable interiors ensure relaxed journeys for professionals. Flexible booking options allow scheduled corporate rides."
},
{
name: "Sedan Car Hire Mumbai",
description: "Sedan car hire in Mumbai provides comfortable and affordable transportation for passengers traveling across the city and nearby destinations. Sedan vehicles offer smooth suspension and fuel-efficient performance suitable for both city and highway travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel, family trips, and tourism visits. Air-conditioned interiors ensure comfortable journeys. Flexible hiring options allow convenient ride scheduling anytime."
}
],

tableData: [
["Sedan Cab Service Mumbai","Sedan Taxi Service Mumbai"],
["Sedan Car Rental Mumbai","Sedan Cab Booking Mumbai"],
["Sedan Airport Cab Mumbai","Sedan Outstation Taxi Mumbai"],
["Sedan One Way Cab Mumbai","Sedan Round Trip Taxi Mumbai"],
["Cheap Sedan Cab Mumbai","Best Sedan Taxi Mumbai"],
["Sedan Cab Per Km Mumbai","Sedan Taxi Booking Mumbai"],
["Sedan Family Cab Mumbai","Sedan Corporate Cab Mumbai"],
["Sedan Car Hire Mumbai","Sedan Taxi Near Me Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Comfortable Sedan Cars for City Travel",
    WhyChoosedescription: "Sedan cabs like Swift Dzire and Honda Amaze are ideal for smooth city travel in Mumbai. They provide comfortable seating, good luggage space, and excellent ride quality for daily travel and airport transfers."
  },
  {
    WhyChooseheading: "Affordable Sedan Taxi Pricing",
    WhyChoosedescription: "Omshree Cabs provides affordable and transparent pricing for sedan cab services in Mumbai. Customers receive clear details about per-kilometer rates, hourly packages, and airport transfer charges before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Sedan Cab Availability",
    WhyChoosedescription: "Our sedan cab service in Mumbai is available 24 hours a day. Whether you need a late-night pickup, early morning airport drop, or daytime city travel, our sedan taxis are always available."
  },
  {
    WhyChooseheading: "Clean & Air-Conditioned Vehicles",
    WhyChoosedescription: "All sedan vehicles in our fleet are fully air-conditioned, regularly cleaned, and well maintained to ensure a comfortable and safe ride for passengers."
  },
  {
    WhyChooseheading: "Ideal for Local & Airport Travel",
    WhyChoosedescription: "Sedan cabs are perfect for local travel within Mumbai, airport transfers, corporate travel, and short outstation trips to nearby destinations like Lonavala and Pune."
  },
  {
    WhyChooseheading: "Professional Chauffeur Drivers",
    WhyChoosedescription: "Our trained drivers are experienced in navigating Mumbai’s roads and traffic conditions. They ensure passengers enjoy a smooth, safe, and punctual travel experience."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Mumbai",
    WhyChoosedescription: "Omshree Cabs provides convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai for hassle-free transportation."
  },
  {
    WhyChooseheading: "Trusted Sedan Cab Service",
    WhyChoosedescription: "Many travelers trust Omshree Cabs for sedan cab services in Mumbai because of our punctual drivers, clean vehicles, and reliable travel experience."
  }
]
};

const faqData = [
  { question: "Do you provide sedan cab services in Mumbai?", answer: "Yes, Omshree Cabs provides reliable sedan cab services in Mumbai for local travel, airport transfers, and outstation trips." },
  { question: "Which sedan cars are available for booking?", answer: "We provide popular sedan cars like Swift Dzire, Honda Amaze, and similar vehicles for comfortable travel." },
  { question: "Are sedan taxis suitable for airport transfers?", answer: "Yes, sedan taxis are commonly used for Mumbai Airport pickup and drop services due to their comfort and luggage space." },
  { question: "How many passengers can travel in a sedan cab?", answer: "Sedan cabs typically accommodate up to four passengers comfortably." },
  { question: "Is sedan cab service available 24 hours?", answer: "Yes, our sedan taxi service in Mumbai operates 24/7 for passenger convenience." },
  { question: "Do you provide sedan cabs for outstation trips?", answer: "Yes, we provide sedan cab services from Mumbai to destinations like Pune, Nashik, Lonavala, Surat, and many other cities." },
  { question: "Are the vehicles air-conditioned?", answer: "Yes, all sedan vehicles provided by Omshree Cabs are fully air-conditioned." },
  { question: "Can I book a sedan cab online?", answer: "Yes, customers can easily book sedan taxis online or via phone for quick confirmation." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended during weekends, holidays, and peak travel seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Suresh Shah",
    feedback:
      "Very reliable sedan cab service in Mumbai. The car was clean and the driver arrived on time for our airport transfer.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Mehta",
    feedback:
      "Excellent sedan taxi service in Mumbai. Smooth ride, professional driver, and affordable pricing.",
    rating: 5
  }
];



















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Sedan Cab Service Mumbai",
  "description": "Omshree Cab provides reliable sedan cab service in Mumbai for local travel, airport transfers, outstation trips, one-way journeys, and round trips. Choose from family, corporate, and affordable sedan options with transparent per km rates, well-maintained vehicles, and experienced chauffeurs for a safe and comfortable ride across Mumbai.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2100"
  }
};






  return (
    <div>
      <Helmet>
  <title>Sedan Cab Service Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab offers sedan cab service in Mumbai for local travel, airport, outstation, one-way, and round trips. Family, corporate, and affordable sedan options with transparent per km rates, well-maintained vehicles, and experienced chauffeurs." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/50.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Sedancabservicemumbai;